var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallboxLoc = function SvgWallboxLoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127 181",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3477 40.1445v40.0977a23.372 20.0495 0 0 0 21.9453-13.1934h14.2304V55.1484h-13.5566a23.372 20.0495 0 0 0-22.6191-15.0039z",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7425 110.1253c-28.4897 0-51.5942-22.0627-51.5942-49.287 0-27.2244 23.1045-49.2871 51.5942-49.2871 28.4987 0 51.5938 22.0627 51.5938 49.287 0 27.2244-23.0951 49.2871-51.5938 49.2871zM63.7425 0C28.7615 0 0 27.099 0 60.5156c0 47.02 63.7425 120.8072 63.7425 120.8072s63.7515-74.2622 63.7515-120.8072C127.494 27.099 98.7324 0 63.7425 0",
    strokeWidth: 0.6,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.0376 0 0 .03592 -66.085 228.5554)",
    strokeWidth: 16.324,
    d: "M3060.729-5143.2504h558.7508v201.6421H3060.729z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "M49.0173 68.909h21.0125v7.2439H49.0173z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.0376 0 0 .03592 -66.085 228.5554)",
    strokeWidth: 16.324,
    d: "M3696.8853-5244.3393h211.0557v1115.8939h-211.0557z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallboxLoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WallboxLoc.9f583af2.svg";
export { ForwardRef as ReactComponent };